import { modals } from './modals';
import type { ModalsApi } from './types';

export const useModals = (): ModalsApi => modals;
